/* NØRZ 2026-10-14 · Side cart: dejar solo PayPal entre los botones de pago rápido.
   Shopify pinta Shop Pay / Apple Pay / Google Pay / PayPal con un componente propio
   (shopify-accelerated-checkout-cart) y no deja elegirlos desde el tema ni tocarlos con CSS
   externo (viven dentro de un shadow DOM). Aquí los recorremos (shadow DOM abierto incluido)
   y ocultamos los que no son PayPal. Solo actúa dentro de .cart-wallets--paypal-only
   (ajuste de tema "cart_paypal_only"). El checkout de Shopify NO se toca.
   Depuración: en la consola, sannaWalletsDebug() lista lo que encuentra. */
(function () {
  if (window.sannaCartWallets) return;
  window.sannaCartWallets = true;

  var HIDE = /shop[-_ ]?pay|apple[-_ ]?pay|google[-_ ]?pay|gpay|amazon[-_ ]?pay|venmo|klarna|meta[-_ ]?pay/i;
  var KEEP = /paypal/i;

  function sig(el) {
    var cls = el.getAttribute && el.getAttribute('class') || '';
    return [
      el.tagName, el.id, cls,
      el.getAttribute('aria-label'), el.getAttribute('title'),
      el.getAttribute('data-testid'), el.getAttribute('name'),
      el.getAttribute('src'), el.getAttribute('wallet'), el.getAttribute('data-wallet')
    ].join(' ');
  }

  function walk(root, fn) {
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      fn(els[i]);
      if (els[i].shadowRoot) walk(els[i].shadowRoot, fn);
    }
  }

  function containsKeep(el) {
    if (KEEP.test(sig(el))) return true;
    var found = false;
    walk(el.shadowRoot || el, function (n) { if (!found && KEEP.test(sig(n))) found = true; });
    if (!found && el.shadowRoot) {
      // también los hijos de luz de un elemento con shadow
      var kids = el.querySelectorAll('*');
      for (var i = 0; i < kids.length && !found; i++) if (KEEP.test(sig(kids[i]))) found = true;
    }
    return found;
  }

  function parentOf(el) {
    if (el.parentElement) return el.parentElement;
    var r = el.getRootNode && el.getRootNode();
    return r && r.host ? r.host : null;
  }

  function process() {
    var hosts = document.querySelectorAll('.cart-wallets--paypal-only');
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h], matches = [], hasKeep = false;
      walk(host, function (el) {
        var s = sig(el);
        if (KEEP.test(s)) hasKeep = true;
        else if (HIDE.test(s)) matches.push(el);
      });

      /* Hasta que PayPal no esté montado no tocamos nada (si no, al no verlo aún se
         ocultaba el contenedor entero y PayPal "desaparecía" al terminar de cargar).
         Mientras tanto el bloque va transparente para que no parpadeen los demás. */
      if (!hasKeep) {
        if (!host.getAttribute('data-sanna-seen')) host.setAttribute('data-sanna-seen', String(Date.now()));
        var waited = Date.now() - parseInt(host.getAttribute('data-sanna-seen'), 10);
        if (waited > 8000) host.style.setProperty('display', 'none', 'important'); // PayPal no disponible
        else host.style.setProperty('opacity', '0', 'important');
        continue;
      }
      host.removeAttribute('data-sanna-seen');
      host.style.removeProperty('display');

      /* Rescate: si algo que habíamos ocultado ahora contiene PayPal, se vuelve a mostrar */
      walk(host, function (el) {
        if (el.getAttribute('data-sanna-hidden') && containsKeep(el)) {
          el.style.removeProperty('display');
          el.removeAttribute('data-sanna-hidden');
        }
      });

      for (var m = 0; m < matches.length; m++) {
        var t = matches[m];
        if (t.getAttribute('data-sanna-hidden')) continue;
        if (containsKeep(t)) continue;
        for (;;) {
          var p = parentOf(t);
          if (!p || p === host || containsKeep(p)) break;
          t = p;
        }
        t.style.setProperty('display', 'none', 'important');
        t.setAttribute('data-sanna-hidden', '1');
      }
      normalize(host);
      tighten(host);
      host.style.setProperty('opacity', '1', 'important');
    }
  }

  /* Tras ocultar los demás, el contenedor de PayPal puede conservar márgenes,
     alturas mínimas o anchos del grid de 3 botones: lo dejamos a 100 % del ancho
     (alineado con Checkout) y sin huecos arriba/abajo. */
  function normalize(host) {
    host.style.setProperty('min-height', '0', 'important');
    var keep = null;
    walk(host, function (el) {
      if (!keep && KEEP.test(sig(el)) && el.tagName.indexOf('-') > -1) keep = el;
    });
    if (!keep) walk(host, function (el) { if (!keep && KEEP.test(sig(el))) keep = el; });
    var t = keep, leaf = true;
    while (t && t !== host) {
      var st = t.style;
      st.setProperty('width', '100%', 'important');
      st.setProperty('max-width', 'none', 'important');
      st.setProperty('margin', '0', 'important');
      st.setProperty('padding', '0', 'important');
      st.setProperty('min-height', '0', 'important');
      st.setProperty('gap', '0', 'important');
      st.setProperty('row-gap', '0', 'important');
      if (!leaf) {
        st.setProperty('height', 'auto', 'important');
        st.setProperty('grid-template-rows', 'none', 'important');
        st.setProperty('grid-auto-rows', 'auto', 'important');
        st.setProperty('flex-basis', 'auto', 'important');
      }
      leaf = false;
      t = parentOf(t);
    }
  }

  /* Shopify reserva la altura de los 3 botones aunque ocultemos 2. Medimos dónde queda
     PayPal respecto a Checkout (arriba) y a los iconos de pago (abajo) y recortamos el
     hueco con márgenes negativos en el contenedor. Deja 8 px arriba y 12 px abajo. */
  function tighten(host) {
    var checkout = document.querySelector('#AjaxCartSubtotal #CheckOut');
    if (!checkout || checkout.offsetParent === null) return;
    var keep = null;
    walk(host, function (el) {
      if (!keep && KEEP.test(sig(el)) && el.tagName.indexOf('-') > -1) keep = el;
    });
    if (!keep) walk(host, function (el) { if (!keep && KEEP.test(sig(el))) keep = el; });
    if (!keep) return;
    keep.style.setProperty('pointer-events', 'auto', 'important');
    host.style.setProperty('margin-top', '0', 'important');
    host.style.setProperty('margin-bottom', '0', 'important');
    var kr = keep.getBoundingClientRect();
    if (!kr.height) return;
    var up = kr.top - checkout.getBoundingClientRect().bottom - 8;
    if (up > 1) host.style.setProperty('margin-top', (-up) + 'px', 'important');
    kr = keep.getBoundingClientRect();
    if (kr.top < checkout.getBoundingClientRect().bottom + 4) host.style.setProperty('margin-top', '0', 'important');
    kr = keep.getBoundingClientRect();
    var next = host.nextElementSibling;
    if (next) {
      var down = next.getBoundingClientRect().top - kr.bottom - 12;
      if (down > 1) host.style.setProperty('margin-bottom', (-down) + 'px', 'important');
    }
  }

  window.sannaWalletsDebug = function () {
    var out = [];
    document.querySelectorAll('.cart-wallets--paypal-only').forEach(function (h) {
      walk(h, function (el) {
        var c = el.getAttribute('class');
        out.push(el.tagName.toLowerCase() + (c ? '.' + c.trim().split(/\s+/).join('.') : '') + (el.shadowRoot ? ' [shadow]' : ''));
      });
    });
    console.log(out.join('\n'));
    return out;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', process);
  else process();
  setInterval(process, 500);
})();
